// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__method-reference[data-v-593c3fa7]{text-transform:capitalize;size:20px;font-weight:700}.form__create-reference[data-v-593c3fa7]{display:flex;flex-direction:column;gap:24px}", ""]);
// Exports
module.exports = exports;
